import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { IoNotificationsOutline } from "react-icons/io5";
import { usePaymentFailureNotifications } from "../../hooks/usePaymentFailureNotifications";

function PaymentFailureBell() {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const isLoggedIn = Boolean(localStorage.getItem("fusionId"));
  const { newFailures, allFailures, badgeCount, isLoading, markAsSeen } =
    usePaymentFailureNotifications({ enabled: isLoggedIn });

  const displayFailures = newFailures.length > 0 ? newFailures : allFailures;

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const togglePanel = (event) => {
    event.stopPropagation();
    const opening = !isOpen;
    setIsOpen(opening);
    if (opening) {
      markAsSeen();
    }
  };

  const handleMarkAllRead = (event) => {
    event.preventDefault();
    markAsSeen();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (!isLoggedIn) return null;

  return (
    <div className="payment-failure-bell" ref={dropdownRef}>
      <button
        type="button"
        className="payment-failure-bell__trigger"
        onClick={togglePanel}
        aria-label="Payment failure notifications"
      >
        <IoNotificationsOutline size={22} />
        {badgeCount > 0 && (
          <span className="payment-failure-bell__badge">
            {badgeCount > 99 ? "99+" : badgeCount}
          </span>
        )}
      </button>

      {isOpen && (
        <div className="payment-failure-bell__dropdown">
          <div className="payment-failure-bell__header">
            <h4>Payment Failures</h4>
            <button
              type="button"
              className="payment-failure-bell__mark-read"
              onClick={handleMarkAllRead}
            >
              Mark all read
            </button>
          </div>

          <div className="payment-failure-bell__list">
            {isLoading && displayFailures.length === 0 ? (
              <p className="payment-failure-bell__empty">Loading...</p>
            ) : displayFailures.length === 0 ? (
              <p className="payment-failure-bell__empty">
                No payment failures
              </p>
            ) : (
              displayFailures.map((order) => (
                <div key={order.orderId} className="payment-failure-bell__item">
                  <p className="payment-failure-bell__title">
                    Payment failed – Order #{order.orderShortId}
                  </p>
                  <p className="payment-failure-bell__meta">
                    Borrower: {order.customer} | {order.dressDetails?.name}
                  </p>
                  {order.rejectReason && (
                    <p className="payment-failure-bell__reason">
                      Reason: {order.rejectReason}
                    </p>
                  )}
                  <p className="payment-failure-bell__date">
                    €{order.price} · {formatDate(order.completedOn)}
                  </p>
                  <Link
                    to={`/complete-order-details/${order.orderId}`}
                    className="payment-failure-bell__link"
                    onClick={() => setIsOpen(false)}
                  >
                    View details
                  </Link>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default PaymentFailureBell;
